<div class="flex flex-col md:flex-row w-full justify-center items-center md:gap-x-6">
  <mat-form-field class="w-full flex-shrink">
    <input matInput [formControl]="filterControl" id="add-item" [testId]="testIds.ITEM_SEARCH_INPUT"
      [matAutocomplete]="auto" placeholder="Add Product/Item" type="search" autofocus #autoCompleteTrigger
      (keydown.enter)="quickAddItem()" />
    <mat-hint>Search by product name or item code</mat-hint>
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="autoCompleteMap">
      <ng-container *ngIf="searchType === 'docket'">
        @for (product of filteredProducts | async; track product.id) {
        <mat-option (onSelectionChange)="listOptionSelected($event)" [value]="product"
          [testId]="testIds.HIRE_SEARCH_RESULT">
          <hire-item-search-result [product]="product"></hire-item-search-result>
        </mat-option>
        }
      </ng-container>

      <ng-container *ngIf="searchType === 'booking'">
        <mat-option testId="booking-search-result" *ngFor="let option of filteredBookingItems | async"
          [testId]="testIds.BOOKING_SEARCH_RESULT" [value]="option" (onSelectionChange)="listOptionSelected($event)">
          <div class="flex items-center gap-2">
            {{ option | bookingItemName }}
            @if (option.product?.virtual) {
            <app-virtual-product-label />
            }
          </div>
        </mat-option>
      </ng-container>
    </mat-autocomplete>
  </mat-form-field>
  <button mat-icon-button class="my-2 md:my-0" (click)="openCategoryGrid()" [testId]="gridTestIds.OPEN_GRID_BUTTON">
    <mat-icon>grid_view</mat-icon>
  </button>
</div>